import { useContext, useEffect, useState } from "react";
import "../../../assets/css/sub-menu.min.css";
import SeleccionContext from "../../../context/Seleccion/SeleccionContext";
import {
  FILTER_PROFILE,
  LIST_ROLES,
  PROFILE_SEL_MASIVA,
  PROFILE_SEL_PROF,
} from "../../../diccionary/Diccionary";
import MediaQuery from "../../ui-responsive/MediaQuery";
import TitleSistema from "./Title";
import { IUserAccess } from "../../../interfaces/ISeleccion";
import { NavLink } from "react-router-dom";
import SubNavTabs from "../../ui/SubNavTabs";
import { GESTION_INGRESO_VISIBLE } from "../../../utils/estadosGestionIngreso";

// Pestañas de Selección. La ruta no siempre sale del rótulo (tildes), así que
// cada pestaña declara su página.
const TABS_SELECCION_PROFESIONAL = [
  { label: "Por Validar", page: "porvalidar" },
  { label: "Preseleccionados", page: "preseleccionados" },
  { label: "Seleccionados", page: "seleccionados" },
  { label: "Gestión de Ingreso", page: "gestioningreso" },
];

const TABS_SELECCION_MASIVA = [
  { label: "Por Validar", page: "porvalidar" },
  { label: "Validados", page: "validados" },
  { label: "Gestión de Ingreso", page: "gestioningreso" },
];

/** Pestañas que se muestran: sin Gestión de Ingreso mientras esté oculta. */
const tabsVisibles = (tabs: { label: string; page: string }[]) =>
  tabs.filter((tab) => GESTION_INGRESO_VISIBLE || tab.page !== "gestioningreso");

/** Rótulo del último tramo del breadcrumb de Selección. */
const labelPaginaSeleccion = (page: string): string => {
  const tab = [...TABS_SELECCION_PROFESIONAL, ...TABS_SELECCION_MASIVA].find(
    (item) => item.page === page
  );
  if (tab) return tab.label;
  return page.charAt(0).toUpperCase() + page.slice(1).toLowerCase();
};

interface ISubMenu {
  itemMenu: string | undefined;
  setItemMenu: Function;
  itemMenuFilter: string;
}

const SubMenu = (props: ISubMenu) => {
  const { itemMenu, setItemMenu, itemMenuFilter } = props;
  const {
    countAssign,
    getCounts,
    listUserAccess,
    getUserAccess,
    profile,
    getToken,
    token,
    roles,
  } = useContext(SeleccionContext);
  const [clienteName, setClienteName] = useState<string>("");
  const [primerLocation, setPrimerLocation] = useState<string>("");
  const [segundaLocation, setSegundaLocation] = useState<string>("");
  const [tercerLocation, setTercerLocation] = useState<string>("");
  const [itemMasivo, setItemMasivo] = useState<string>("");
  const [itemProf, setItemProf] = useState<string>("");
  const [itemSelection, setItemSelection] = useState<string>("itemSelection");
  const [currenFilterStorage, setCurrentFilterStorage] = useState<any>();
  const { width, sm } = MediaQuery();

  useEffect(() => {
    getToken();
  }, []);

  useEffect(() => {
    if (token) {
      getUserAccess({ token });
      getCounts({ token });
    }
  }, [token]);

  useEffect(() => {
    if (segundaLocation) {
      const nameCli = countAssign.find(({ clienteId }: any) =>
        [segundaLocation, tercerLocation].includes(clienteId)
      );
      setClienteName(nameCli?.clienteNombre ?? "");
    }
  }, [segundaLocation, getCounts]);

  useEffect(() => {
    if (localStorage.getItem(itemSelection)) {
      const copyStorage: any = localStorage.getItem(itemSelection);
      setCurrentFilterStorage(JSON.parse(copyStorage));
    }
  }, [localStorage.getItem(itemSelection)]);

  useEffect(() => {
    if (listUserAccess) {
      setItemMasivo(listUserAccess.map(({ masivo }: IUserAccess) => masivo));
      setItemProf(
        listUserAccess.map(({ profesional }: IUserAccess) => profesional)
      );
    }
  }, [listUserAccess]);

  useEffect(() => {
    try {
      const url = window.location.pathname;
      const parts = url.split("/");
      const primerValor = parts[1];
      const segundoValor = parts[2] ?? "";
      const tercerValor = parts[3] ?? "";
      setPrimerLocation(primerValor);
      setSegundaLocation(segundoValor);
      setTercerLocation(tercerValor);
    } catch (error) {
      console.log("error en crear rutas");
    }
  }, [segundaLocation, itemMenu]);

  const handleClickGoRuta = (values: any) => {
    const { ruta, page, page2 } = values;
    // cleanStaorageFilterOperaciones();
    if (page2) {
      return `/${ruta}/${page}/${page2}`;
    }
    if (page) {
      return `/${ruta}/${page}`;
    } else {
      return `/${ruta}`;
    }
  };

  const cleanStaorageFilterOperaciones = () => {
    localStorage.setItem("Filtros2", "");
    localStorage.setItem("filterGeneralDashboard", "");
    localStorage.setItem("filtroProcesoActivo", "");
    localStorage.setItem("filtroDotacionVigente", "");
    localStorage.setItem("filtroContratosSolicitudPendientes", "");
    localStorage.setItem("filtroContratoSolProcesadas", "");
  };

  // Operaciones y Contratos también ven Selección Masiva/Profesional e
  // Inhabilitados completos (solo lectura), con las mismas pestañas.
  const isOpsOrContrato = [FILTER_PROFILE.tw_ops, FILTER_PROFILE.tw_contrato].includes(profile);
  const SELECTION_SECTIONS = ["registros", "inhabilitados", "procesos", "seleccionprofesional", "seleccionmasiva"];
  const isSelectionSection = SELECTION_SECTIONS.includes(primerLocation ?? "");
  const sel_all =
    PROFILE_SEL_PROF.includes(profile) || PROFILE_SEL_MASIVA.includes(profile) || isOpsOrContrato;

  return (
    <>
      {width >= sm && (
        <>
          {primerLocation === "registros" && segundaLocation !== "traspasos" && (
            <>
              <section className="content-submenu">
                {sel_all && (
                  <div className="content-page">
                    <NavLink
                      className="page-tag-nav"
                      to={handleClickGoRuta({
                        ruta: primerLocation,
                        page: "habilitados",
                      })}
                    >
                      Registros
                    </NavLink>
                    <span className="page-tag separator">›</span>
                    <span className="page-tag">
                      {segundaLocation.charAt(0).toUpperCase()}
                      {segundaLocation.slice(1).toLowerCase()}
                    </span>
                  </div>
                )}
              </section>

              {segundaLocation && segundaLocation == "habilitados" && (
                <TitleSistema
                  title="CANDIDATOS HABILITADOS"
                />
              )}
            </>
          )}

          {primerLocation === "inhabilitados" && (
            <>
              <section className="content-submenu">
                {sel_all && (
                  <div className="content-page">
                    <NavLink
                      className="page-tag-nav"
                      to={handleClickGoRuta({ ruta: "inhabilitados" })}
                    >
                      Registros
                    </NavLink>
                    <span className="page-tag separator">›</span>
                    <span className="page-tag">Inhabilitados</span>
                  </div>
                )}
              </section>

              <TitleSistema
                title="CANDIDATOS INHABILITADOS"
              />
            </>
          )}

          {primerLocation === "registros" && segundaLocation === "traspasos" && (
            <div
              style={{
                width: "100%",
                textAlign: "center",
                padding: "32px 0 16px",
              }}
            >
              <h1
                style={{
                  fontFamily: "Roboto, sans-serif",
                  fontSize: "22px",
                  fontWeight: 600,
                  color: "#48566b",
                  margin: 0,
                }}
              >
                Traspaso de Candidatos
              </h1>
            </div>
          )}

          {primerLocation === "procesos" && (
            <>
              <section className="content-submenu">
                {sel_all && (
                  <>
                    <div className="content-page">
                      {currenFilterStorage &&
                        currenFilterStorage == "profesional" ? (
                        <>
                          <NavLink
                            className="page-tag-nav"
                            to={handleClickGoRuta({
                              ruta: "seleccionprofesional",
                              page: "porvalidar",
                            })}
                          >
                            Selección Profesional
                          </NavLink>
                          <label className="page-tag">/</label>
                        </>
                      ) : (
                        <>
                          <NavLink
                            className="page-tag-nav"
                            to={handleClickGoRuta({
                              ruta: "seleccionmasiva",
                              page: "porvalidar",
                            })}
                          >
                            Selección Masiva
                          </NavLink>
                          <span className="page-tag separator">›</span>
                        </>
                      )}
                      <NavLink
                        className="page-tag-nav"
                        to={handleClickGoRuta({
                          ruta: primerLocation,
                          page: "activos",
                        })}
                      >
                        Procesos
                      </NavLink>
                      <span className="page-tag separator">›</span>
                      <span className="page-tag">
                        {segundaLocation.charAt(0).toUpperCase()}
                        {segundaLocation.slice(1).toLowerCase()}
                      </span>
                    </div>

                    <SubNavTabs
                      tabs={["Solicitudes", "Activos"].map((item) => ({
                        label: item,
                        to: handleClickGoRuta({
                          ruta: primerLocation,
                          page: item.toLowerCase(),
                        }),
                        isActive:
                          item ===
                          segundaLocation.charAt(0).toUpperCase() +
                            segundaLocation.slice(1).toLowerCase(),
                      }))}
                    />
                  </>
                )}
              </section>

              {segundaLocation && segundaLocation == "activos" && (
                <TitleSistema title="PROCESOS ACTIVOS" />
              )}

              {segundaLocation && segundaLocation == "inactivos" && (
                <TitleSistema
                  title="PROCESOS INACTIVOS"
                  subtitle="En esta sección puedes visualizar los procesos de reclutamiento solicitados y sin asignación de equipo."
                />
              )}
            </>
          )}

          {primerLocation === "seleccionprofesional" && (
            <>
              <section className="content-submenu">
                {itemProf && (
                  <>
                    <div className="content-page">
                      <NavLink
                        className="page-tag-nav"
                        to={handleClickGoRuta({
                          ruta: "seleccionprofesional",
                          page: "porvalidar",
                        })}
                      >
                        Selección Profesional
                      </NavLink>
                      <span className="page-tag separator">›</span>
                      <NavLink
                        className="page-tag-nav"
                        to={handleClickGoRuta({
                          ruta: "seleccionprofesional",
                          page: "porvalidar",
                        })}
                      >
                        Selección
                      </NavLink>
                      <span className="page-tag separator">›</span>
                      <span className="page-tag">
                        {labelPaginaSeleccion(segundaLocation)}
                      </span>
                    </div>

                    <SubNavTabs
                      tabs={tabsVisibles(TABS_SELECCION_PROFESIONAL).map(({ label, page }) => ({
                        label,
                        to: handleClickGoRuta({ ruta: primerLocation, page }),
                        isActive: page === segundaLocation,
                      }))}
                    />
                  </>
                )}
              </section>

              {segundaLocation && segundaLocation == "porvalidar" && (
                <TitleSistema
                  title="CANDIDATOS CON PROCESO ACTIVO"
                />
              )}

              {segundaLocation && segundaLocation == "preseleccionados" && (
                <TitleSistema
                  title="CANDIDATOS PRESELECCIONADOS"
                  subtitle="En esta sección puede ver los candidatos con una primera validación del cliente. Puede avanzarlos o descartarlos del proceso, confirmar su entrevista y realizar el examen psico laboral."
                />
              )}

              {segundaLocation && segundaLocation == "seleccionados" && (
                <TitleSistema
                  title="CANDIDATOS SELECCIONADOS"
                  subtitle="En esta sección puede ver los candidatos con ambas validaciones del Cliente. Puede realizar el examen psico laboral, descartar y avanzarlos a operaciones para su contratación."
                  note={
                    "Nota: El registro del candidato debe contar con todos los datos obligatorios para enviar a Operaciones."
                  }
                />
              )}

              {segundaLocation && segundaLocation == "gestioningreso" && (
                <TitleSistema title="GESTIÓN DE INGRESO" />
              )}
            </>
          )}

          {primerLocation === "seleccionmasiva" && (
            <>
              <section className="content-submenu">
                {itemMasivo && (
                  <>
                    <div className="content-page">
                      <NavLink
                        className="page-tag-nav"
                        to={handleClickGoRuta({
                          ruta: "seleccionmasiva",
                          page: "porvalidar",
                        })}
                      >
                        Selección Masiva
                      </NavLink>
                      <span className="page-tag separator">›</span>
                      <NavLink
                        className="page-tag-nav"
                        to={handleClickGoRuta({
                          ruta: "seleccionmasiva",
                          page: "porvalidar",
                        })}
                      >
                        Selección
                      </NavLink>
                      <span className="page-tag separator">›</span>
                      <span className="page-tag">
                        {labelPaginaSeleccion(segundaLocation)}
                      </span>
                    </div>

                    <SubNavTabs
                      tabs={tabsVisibles(TABS_SELECCION_MASIVA).map(({ label, page }) => ({
                        label,
                        to: handleClickGoRuta({ ruta: primerLocation, page }),
                        isActive: page === segundaLocation,
                      }))}
                    />
                  </>
                )}
              </section>

              {segundaLocation && segundaLocation == "porvalidar" && (
                <TitleSistema
                  title="CANDIDATOS CON PROCESO ACTIVO"
                />
              )}

              {segundaLocation && segundaLocation == "validados" && (
                <TitleSistema title="CANDIDATOS VALIDADOS" />
              )}

              {segundaLocation && segundaLocation == "gestioningreso" && (
                <TitleSistema title="GESTIÓN DE INGRESO" />
              )}
            </>
          )}

          {/* Submenú de Operaciones: no en las secciones de Selección, que ya
              tienen el suyo (tw_ops ahora también entra a ellas). */}
          {!isSelectionSection && [
            FILTER_PROFILE.admin_ops,
            FILTER_PROFILE.tw_ops,
            FILTER_PROFILE.adm_tw,
            FILTER_PROFILE.adm_ti,
          ].includes(profile) && (
              <>
                {(roles && roles.includes(LIST_ROLES.JEFE_OPS)) ||
                  [FILTER_PROFILE.admin_ops].includes(profile) ? (
                  <>
                    <section className="content-submenu">
                      {segundaLocation && (
                        <>
                          <div className="content-page">
                            <NavLink
                              className="page-tag-nav"
                              to={handleClickGoRuta({
                                ruta: "resumen",
                              })}
                            >
                              Gestión Contratación
                            </NavLink>
                            <label className="page-tag">/</label>
                            <NavLink
                              className="page-tag"
                              to={handleClickGoRuta({
                                ruta: "resumen",
                              })}
                            >
                              Inicio
                            </NavLink>
                          </div>
                        </>
                      )}
                    </section>
                  </>
                ) : (
                  <>
                    {/* SUBMENU RESUMEN */}
                    {primerLocation === "resumen" && (
                      <>
                        <section className="content-submenu">
                          {segundaLocation && (
                            <>
                              <div className="content-page">
                                <NavLink
                                  className="page-tag-nav"
                                  to={handleClickGoRuta({
                                    ruta: "contratacion",
                                  })}
                                >
                                  Clientes Asignados
                                </NavLink>
                                <label className="page-tag">/</label>
                                <label className="page-tag-nav">
                                  {clienteName}
                                </label>
                                <label className="page-tag">/</label>
                                <NavLink
                                  className="page-tag"
                                  to={handleClickGoRuta({
                                    ruta: "resumen",
                                    page: segundaLocation,
                                  })}
                                >
                                  Resumen
                                </NavLink>
                              </div>

                              <div className="content-nav">
                                {[
                                  "Resumen",
                                  "Ingresos",
                                  "Dotacion Activa",
                                  "Bajas Confirmadas",
                                ].map((item: any) => {
                                  return item == "Ingresos" ? (
                                    <NavLink
                                      key={item}
                                      className={`nav-tag ${item.replace(/\s/g, "").toLowerCase() ==
                                          primerLocation
                                          ? "select"
                                          : ""
                                        }`}
                                      to={handleClickGoRuta({
                                        ruta: "contratacion",
                                        page: segundaLocation,
                                      })}
                                    >
                                      {item}
                                    </NavLink>
                                  ) : (
                                    <NavLink
                                      key={item}
                                      className={`nav-tag ${item.replace(/\s/g, "").toLowerCase() ==
                                          primerLocation
                                          ? "select"
                                          : ""
                                        }`}
                                      to={handleClickGoRuta({
                                        ruta: item
                                          .replace(/\s/g, "")
                                          .toLowerCase(),
                                        page: segundaLocation,
                                      })}
                                    >
                                      {item}
                                    </NavLink>
                                  );
                                })}
                              </div>
                            </>
                          )}
                        </section>

                        {/*segundaLocation && (
                          <TitleDashboard
                            title="Bienvenido a la Gestión de Contratación de Candidatos"
                          /> 
                      )*/}
                      </>
                    )}
                    {/* SUBMENU CONTRATACION */}
                    {primerLocation == "contratacion" && !segundaLocation && (
                      <>
                        <section className="content-submenu">
                          <>
                            <div className="content-page">
                              <NavLink
                                className="page-tag-nav"
                                to={handleClickGoRuta({
                                  ruta: "contratacion",
                                })}
                              >
                                Clientes Asignados
                              </NavLink>
                            </div>
                          </>
                        </section>

                        {primerLocation == "contratacion" && !segundaLocation && (
                          <TitleSistema
                            title="CLIENTES ASIGNADOS PARA INGRESOS"
                            subtitle="Aquí puede revisar los clientes asignados, en cada uno se encuentra la lista de candidatos aprobados en espera de solicitud de contrato."
                          />
                        )}
                      </>
                    )}
                    {primerLocation === "contratacion" && (
                      <>
                        <section className="content-submenu">
                          {segundaLocation && (
                            <>
                              <div className="content-page">
                                <NavLink
                                  className="page-tag-nav"
                                  to={handleClickGoRuta({
                                    ruta: "contratacion",
                                  })}
                                >
                                  Clientes Asignados
                                </NavLink>
                                <label className="page-tag">/</label>
                                <label className="page-tag-nav">
                                  {clienteName}
                                </label>
                                <label className="page-tag">/</label>
                                <NavLink
                                  className="page-tag"
                                  to={handleClickGoRuta({
                                    ruta: "contratacion",
                                    page: segundaLocation,
                                  })}
                                >
                                  Ingresos
                                </NavLink>
                              </div>

                              <div className="content-nav">
                                {[
                                  "Resumen",
                                  "Ingresos",
                                  "Dotacion Activa",
                                  "Bajas Confirmadas",
                                ].map((item: any) => {
                                  return item == "Ingresos" ? (
                                    <NavLink
                                      key={item}
                                      className={`nav-tag ${"contratacion" == primerLocation
                                          ? "select"
                                          : ""
                                        }`}
                                      to={handleClickGoRuta({
                                        ruta: "contratacion",
                                        page: segundaLocation,
                                      })}
                                    >
                                      <label onClick={() => cleanStaorageFilterOperaciones()}>{item}</label>
                                    </NavLink>
                                  ) : (
                                    <NavLink
                                      key={item}
                                      className={`nav-tag ${item.replace(/\s/g, "").toLowerCase() ==
                                          primerLocation
                                          ? "select"
                                          : ""
                                        }`}
                                      to={handleClickGoRuta({
                                        ruta: item
                                          .replace(/\s/g, "")
                                          .toLowerCase(),
                                        page: segundaLocation,
                                      })}
                                    >
                                      <label onClick={() => cleanStaorageFilterOperaciones()}>{item}</label>
                                    </NavLink>
                                  );
                                })}
                              </div>
                            </>
                          )}
                        </section>

                        {segundaLocation && (
                          <TitleSistema
                            title="INGRESOS"
                            subtitle="En esta opción puedes validar la documentación de los candidatos y solicitar su contratación. "
                          />
                        )}
                      </>
                    )}
                    {/* SUBMENU DOTACIONES ACTIVAS */}
                    {primerLocation === "dotacionactiva" && (
                      <>
                        <section className="content-submenu">
                          {segundaLocation && (
                            <>
                              <div className="content-page">
                                <NavLink
                                  className="page-tag-nav"
                                  to={handleClickGoRuta({
                                    ruta: "contratacion",
                                  })}
                                >
                                  Clientes Asignados
                                </NavLink>
                                <label className="page-tag">/</label>
                                <label className="page-tag-nav">
                                  {clienteName}
                                </label>
                                <label className="page-tag">/</label>
                                <NavLink
                                  className="page-tag"
                                  to={handleClickGoRuta({
                                    ruta: "dotacionactiva",
                                    page: segundaLocation,
                                  })}
                                >
                                  Dotación Activa
                                </NavLink>
                              </div>

                              <div className="content-nav">
                                {[
                                  "Resumen",
                                  "Ingresos",
                                  "Dotacion Activa",
                                  "Bajas Confirmadas",
                                ].map((item: any) => {
                                  return item == "Ingresos" ? (
                                    <NavLink
                                      key={item}
                                      className={`nav-tag ${item.replace(/\s/g, "").toLowerCase() ==
                                          primerLocation
                                          ? "select"
                                          : ""
                                        }`}
                                      to={handleClickGoRuta({
                                        ruta: "contratacion",
                                        page: segundaLocation,
                                      })}
                                    >
                                      <label onClick={() => cleanStaorageFilterOperaciones()}>{item}</label>
                                    </NavLink>
                                  ) : (
                                    <NavLink
                                      key={item}
                                      className={`nav-tag ${item.replace(/\s/g, "").toLowerCase() ==
                                          primerLocation
                                          ? "select"
                                          : ""
                                        }`}
                                      to={handleClickGoRuta({
                                        ruta: item
                                          .replace(/\s/g, "")
                                          .toLowerCase(),
                                        page: segundaLocation,
                                      })}
                                    >
                                      <label onClick={() => cleanStaorageFilterOperaciones()}>{item}</label>
                                    </NavLink>
                                  );
                                })}
                              </div>
                            </>
                          )}
                        </section>

                        {segundaLocation && (
                          <TitleSistema
                            title="DOTACIÓN ACTIVA"
                            subtitle="En esta opción podrás ver los contratos próximos a vencer, confirmar bajas, renovar y actualizar datos de contratos."
                          />
                        )}
                      </>
                    )}
                    {/* SUBMENU BAJAS CONFIRMADAS */}
                    {primerLocation === "bajasconfirmadas" && (
                      <>
                        <section className="content-submenu">
                          {segundaLocation && (
                            <>
                              <div className="content-page">
                                <NavLink
                                  className="page-tag-nav"
                                  to={handleClickGoRuta({
                                    ruta: "contratacion",
                                  })}
                                >
                                  Clientes Asignados
                                </NavLink>
                                <label className="page-tag">/</label>
                                <label className="page-tag-nav">
                                  {clienteName}
                                </label>
                                <label className="page-tag">/</label>
                                <NavLink
                                  className="page-tag"
                                  to={handleClickGoRuta({
                                    ruta: "bajasconfirmadas",
                                    page: segundaLocation,
                                  })}
                                >
                                  Bajas Confirmadas
                                </NavLink>
                              </div>

                              <div className="content-nav">
                                {[
                                  "Resumen",
                                  "Ingresos",
                                  "Dotacion Activa",
                                  "Bajas Confirmadas",
                                ].map((item: any) => {
                                  return item == "Ingresos" ? (
                                    <NavLink
                                      key={item}
                                      to={handleClickGoRuta({
                                        ruta: "contratacion",
                                        page: segundaLocation,
                                      })}
                                      className={`nav-tag ${item.replace(/\s/g, "").toLowerCase() ==
                                          primerLocation
                                          ? "select"
                                          : ""
                                        }`}
                                    >
                                      <label onClick={() => cleanStaorageFilterOperaciones()}>{item}</label>
                                    </NavLink>
                                  ) : (
                                    <NavLink
                                      key={item}
                                      className={`nav-tag ${item.replace(/\s/g, "").toLowerCase() ==
                                          primerLocation
                                          ? "select"
                                          : ""
                                        }`}
                                      to={handleClickGoRuta({
                                        ruta: item
                                          .replace(/\s/g, "")
                                          .toLowerCase(),
                                        page: segundaLocation,
                                      })}
                                    >
                                      <label onClick={() => cleanStaorageFilterOperaciones()}>{item}</label>
                                    </NavLink>
                                  );
                                })}
                              </div>
                            </>
                          )}
                        </section>

                        {segundaLocation && (
                          <TitleSistema
                            title="BAJAS CONFIRMADAS"
                            subtitle="En esta opción podrás ver los contratos con la baja confirmada."
                          />
                        )}
                      </>
                    )}

                    {/* SUBMENU CONTRATACION */}
                    {primerLocation == "contratos" && !segundaLocation && (
                      <>
                        <section className="content-submenu">
                          <>
                            <div className="content-page">
                              <NavLink
                                className="page-tag-nav"
                                to={handleClickGoRuta({
                                  ruta: "contratacion",
                                })}
                              >
                                Clientes Asignados
                              </NavLink>
                            </div>
                          </>
                        </section>

                        {primerLocation == "contratos" && !segundaLocation && (
                          <TitleSistema
                            title="CLIENTES ASIGNADOS PARA INGRESOS"
                            subtitle="Aquí puede revisar los clientes asignados, en cada uno se encuentra la lista de candidatos aprobados en espera de solicitud de contrato."
                          />
                        )}
                      </>
                    )}

                    {/* SUBMENU CONTRATO */}
                    {primerLocation === "contratos" &&
                      segundaLocation == "resumen" && (
                        <>
                          <section className="content-submenu">
                            {segundaLocation && (
                              <>
                                <div className="content-page">
                                  <NavLink
                                    className="page-tag-nav"
                                    to={handleClickGoRuta({
                                      ruta: "contratos",
                                      page: "resumen",
                                    })}
                                  >
                                    Contratos
                                  </NavLink>
                                </div>

                                <div className="content-nav">
                                  {["Resumen", "Pendientes", "Procesadas"].map(
                                    (item: any) => {
                                      return item == "resumen" ? (
                                        <NavLink
                                          key={item}
                                          className={`nav-tag ${item
                                              .replace(/\s/g, "")
                                              .toLowerCase() == segundaLocation
                                              ? "select"
                                              : ""
                                            }`}
                                          to={handleClickGoRuta({
                                            ruta: primerLocation,
                                            page: segundaLocation,
                                            page2: tercerLocation,
                                          })}
                                        >
                                          <label onClick={() => cleanStaorageFilterOperaciones()}>{item}</label>
                                        </NavLink>
                                      ) : (
                                        <NavLink
                                          key={item}
                                          className={`nav-tag ${item
                                              .replace(/\s/g, "")
                                              .toLowerCase() == segundaLocation
                                              ? "select"
                                              : ""
                                            }`}
                                          to={handleClickGoRuta({
                                            ruta: primerLocation,
                                            page: item
                                              .replace(/\s/g, "")
                                              .toLowerCase(),
                                            page2: tercerLocation,
                                          })}
                                        >
                                          <label onClick={() => cleanStaorageFilterOperaciones()}>{item}</label>
                                        </NavLink>
                                      );
                                    }
                                  )}
                                </div>
                              </>
                            )}
                          </section>
                        </>
                      )}

                    {/* SUBMENU CONTRATO */}
                    {primerLocation === "contratos" &&
                      segundaLocation == "pendientes" && (
                        <>
                          <section className="content-submenu">
                            {segundaLocation && (
                              <>
                                <div className="content-page">
                                  <NavLink
                                    className="page-tag-nav"
                                    to={handleClickGoRuta({
                                      ruta: "contratos",
                                      page: "resumen",
                                    })}
                                  >
                                    Clientes Asignados
                                  </NavLink>
                                  {clienteName && (
                                    <>
                                      <label className="page-tag">/</label>
                                      <label className="page-tag-nav">
                                        {clienteName}
                                      </label>
                                    </>
                                  )}
                                  <label className="page-tag">/</label>
                                  <NavLink
                                    className="page-tag"
                                    to={handleClickGoRuta({
                                      ruta: primerLocation,
                                      page: segundaLocation,
                                      page2: tercerLocation,
                                    })}
                                  >
                                    Pendientes
                                  </NavLink>
                                </div>

                                <div className="content-nav">
                                  {["Resumen", "Pendientes", "Procesadas"].map(
                                    (item: any) => {
                                      return item == "pendientes" ? (
                                        <NavLink
                                          key={item}
                                          className={`nav-tag ${item
                                              .replace(/\s/g, "")
                                              .toLowerCase() == segundaLocation
                                              ? "select"
                                              : ""
                                            }`}
                                          to={handleClickGoRuta({
                                            ruta: primerLocation,
                                            page: segundaLocation,
                                            page2: tercerLocation,
                                          })}
                                        >
                                          <label onClick={() => cleanStaorageFilterOperaciones()}>{item}</label>
                                        </NavLink>
                                      ) : (
                                        <NavLink
                                          key={item}
                                          className={`nav-tag ${item
                                              .replace(/\s/g, "")
                                              .toLowerCase() == segundaLocation
                                              ? "select"
                                              : ""
                                            }`}
                                          to={handleClickGoRuta({
                                            ruta: primerLocation,
                                            page: item
                                              .replace(/\s/g, "")
                                              .toLowerCase(),
                                            page2: tercerLocation,
                                          })}
                                        >
                                          <label onClick={() => cleanStaorageFilterOperaciones()}>{item}</label>
                                        </NavLink>
                                      );
                                    }
                                  )}
                                </div>
                              </>
                            )}
                          </section>

                          <TitleSistema
                            title="SOLICITUDES PENDIENTES"
                            subtitle="En esta sección podrás ver las solicitudes de contratos recibidas."
                          />
                        </>
                      )}

                    {/* SUBMENU PROCESADAS */}
                    {primerLocation == "contratos" &&
                      segundaLocation == "procesadas" && (
                        <>
                          <section className="content-submenu">
                            {segundaLocation && (
                              <>
                                <div className="content-page">
                                  <NavLink
                                    className="page-tag-nav"
                                    to={handleClickGoRuta({
                                      ruta: "contratos",
                                      page: "resumen",
                                    })}
                                  >
                                    Clientes Asignados
                                  </NavLink>
                                  {clienteName && (
                                    <>
                                      <label className="page-tag">/</label>
                                      <label className="page-tag-nav">
                                        {clienteName}
                                      </label>
                                    </>
                                  )}
                                  <label className="page-tag">/</label>
                                  <NavLink
                                    className="page-tag"
                                    to={handleClickGoRuta({
                                      ruta: primerLocation,
                                      page: segundaLocation,
                                      page2: tercerLocation,
                                    })}
                                  >
                                    Procesadas
                                  </NavLink>
                                </div>

                                <div className="content-nav">
                                  {["Resumen", "Pendientes", "Procesadas"].map(
                                    (item: any) => {
                                      return item == "procesadas" ? (
                                        <NavLink
                                          key={item}
                                          className={`nav-tag ${item
                                              .replace(/\s/g, "")
                                              .toLowerCase() == segundaLocation
                                              ? "select"
                                              : ""
                                            }`}
                                          to={handleClickGoRuta({
                                            ruta: primerLocation,
                                            page: segundaLocation,
                                            page2: tercerLocation,
                                          })}
                                        >
                                          <label onClick={() => cleanStaorageFilterOperaciones()}>{item}</label>
                                        </NavLink>
                                      ) : (
                                        <NavLink
                                          key={item}
                                          className={`nav-tag ${item
                                              .replace(/\s/g, "")
                                              .toLowerCase() == segundaLocation
                                              ? "select"
                                              : ""
                                            }`}
                                          to={handleClickGoRuta({
                                            ruta: primerLocation,
                                            page: item
                                              .replace(/\s/g, "")
                                              .toLowerCase(),
                                            page2: tercerLocation,
                                          })}
                                        >
                                          <label onClick={() => cleanStaorageFilterOperaciones()}>{item}</label>
                                        </NavLink>
                                      );
                                    }
                                  )}
                                </div>
                              </>
                            )}
                          </section>

                          <TitleSistema
                            title="SOLICITUDES PROCESADAS"
                            subtitle="En esta sección podrás ver un histórico de las solicitudes procesadas."
                          />
                        </>
                      )}
                  </>
                )}
              </>
            )}
        </>
      )}
    </>
  );
};

export default SubMenu;
